import { createContext, useContext, useState } from 'react'
import { supabase } from '../supabase/client';

export const PersonContext = createContext();

export const usePerson = () => {
    const context = useContext(PersonContext);
    if (!context) {
        throw new Error('usePerson debe estar dentro del proveedor PersonContext')
    }
    return context;
};

export const PersonContextProvider = ({ children }) => {

    const [persons, setPersons] = useState([])
    const [personsType, setPersonsType] = useState([])
    const [modal, setModal] = useState(false)

    const getPersons = async () => {
        const { error, data } = await supabase.from('persons').select()
        if (error) throw (error.message)
        setPersons(data)
    }

    const getPerson = async (id) => {
        const { error, data } = await supabase.from('persons')
            .select()
            .eq('id', id)
            .single()
        if (error) throw (error.message)
        return data
    }

    const getRepresentative = async (id) => {
        const { error, data } = await supabase.from('representatives')
            .select()
            .eq('persons_id', id)
            .single()
        if (error) return { code: 404, data: error }
        return { code: 200, data: data }
    }

    const createPersons = async (formData, formRepresentative, representative) => {
        try {
            const { data, statusText, status, error } = await supabase
                .from('persons')
                .insert({
                    name: formData.name,
                    document: formData.document,
                    email: formData.email,
                    phone: formData.phone,
                    address: formData.address,
                    representative: formData.representative,
                    persons_type_id: formData.persons_type,
                })
                .select()
                .single()

            if (representative && status === 201) {
                await createRepresentative(formRepresentative, data.id)
            }

            if (status !== 201) return { title: statusText, msg: error.message + " Code:[" + error.code + "]", icon: 'error' }
            getPersons()
            setModal(true)
            return { title: statusText, msg: "Registro creado correctamente", icon: 'success' }
        } catch (e) {
            console.error(e)
        }
    }

    const createRepresentative = async (formData, id) => {
        try {
            await supabase
                .from('representatives')
                .insert({
                    name: formData.name,
                    document: formData.document,
                    email: formData.email,
                    phone: formData.phone,
                    address: formData.address,
                    persons_id: id
                })
        } catch (e) {
            console.error(e)
        }
    }

    const updatePersons = async (formData, id, formRepresentative, representative) => {
        try {
            const { error, status, statusText } = await supabase
                .from('persons')
                .update({
                    name: formData.name,
                    document: formData.document,
                    email: formData.email,
                    phone: formData.phone,
                    address: formData.address,
                    representative: formData.representative,
                    persons_type_id: formData.persons_type,
                })
                .eq('id', id)
                .select()

            if (representative && status === 200) {
                const { code } = await getRepresentative(id)
                code === 200 ?
                    await updateRepresentative(formRepresentative, id) :
                    createRepresentative(formRepresentative, id)
            }

            if (status !== 200) return {
                title: statusText,
                msg: error.message + " Code:[" + error.code + "]",
                icon: 'error'
            }
            getPersons()
            setModal(true)
            return ({ title: statusText, msg: 'Usuario actualizado correctamente', icon: 'success' })
        } catch (e) {
            console.error(e)
        }
    }

    const updateRepresentative = async (formData, id) => {
        try {
            const { error, status, statusText } = await supabase
                .from('representatives')
                .update({
                    name: formData.name,
                    document: formData.document,
                    email: formData.email,
                    phone: formData.phone,
                    address: formData.address,
                })
                .eq('persons_id', id)
                .select()

            if (status !== 200) return { title: statusText, msg: error.message + " Code:[" + error.code + "]", icon: 'error', status: status }
            getPersons()
            setModal(true)
            return ({ title: statusText, msg: 'Usuario actualizado correctamente', icon: 'success', status: status })
        } catch (e) {
            console.error(e)
        }
    }

    const deletePerson = async (id) => {
        try {
            const { error, status } = await supabase
                .from('persons')
                .delete()
                .eq('id', id)

            if (status !== 204) return { msg: error.message + " Code:[" + error.code + "]", status: status }
            getPersons()
            return ({ msg: 'El registro ha sido eliminado.', status: status })
        } catch (e) {
            console.error(e)
        }
    }

    const getPersonsType = async () => {
        const { error, data } = await supabase.from('persons_type').select()
        if (error) throw (error.message)
        setPersonsType(data)
    }

    const getModal = () => {
        setModal(false)
    }

    return (
        <PersonContext.Provider value={{
            modal,
            persons,
            getPersons,
            getPerson,
            getRepresentative,
            createPersons,
            updatePersons,
            deletePerson,
            personsType,
            getPersonsType,
            getModal
        }}>
            {children}
        </PersonContext.Provider>
    )
}